export default __webpack_public_path__ + "static/media/down-white-16x7.66a1cd49.svg";